import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import TypographyWithTooltip from 'components/shared/TypographyWithTooltip';
import Zoom from '@material-ui/core/Zoom';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  container: {
    position: 'relative',
    minHeight: '120px',
    height: 'auto',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      borderBottom: `1px solid ${theme.palette.white}`,
      color: theme.palette.white,
      '& $description': {
        color: theme.palette.white
      },
      '& $tableTitle': {
        color: theme.palette.white
      },
      '& $buttonIcon': {
        backgroundColor: theme.palette.white
      },
      '& $link': {
        color: theme.palette.white
      },
      '& $arrowIcon': {
        color: theme.palette.primary.main
      },
      '& $tableCell, & $tableRow': {
        color: theme.palette.white
      }
    },
    '@media (max-width: 330px)': {
      width: '250px',
    },
  },
  title: {
    fontSize: '16px',
    textTransform: 'uppercase',
    fontWeight: '600'
  },
  description: {
    fontSize: theme.customStyles.baseWdigetDates.fontSize,
    color: theme.palette.grey.dark,
  },
  tableTitle: {
    fontSize: theme.customStyles.baseWdigetDates.fontSize,
    color: theme.palette.grey.dark,
    fontWeight: 'bold',
  },
  tableCell: {
    fontSize: theme.customStyles.baseWdigetDates.fontSize,
    color: theme.palette.grey.dark
  },
  tableRow: {
    fontSize: theme.customStyles.baseWdigetDates.fontSize,
    color: theme.palette.grey.dark
  },
  link: {
    color: theme.palette.accent.main,
    textDecoration: 'none'
  },
  buttonIcon: {
    backgroundColor: `${theme.palette.lightBlue.main}33`,
    marginRight: '10px',
    padding: '7px'
  },
  arrowIcon: {
    color: theme.palette.accent.main,
    fontSize: '20px'
  },
  tableContainer: {
    overflow: 'hidden',
    display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    height: 'auto',
    '@media (max-width: 480px)': {
      flexDirection: 'column'
    },
  },
  tableRow: {
    flexDirection: 'column',
    flex: 1,
    '@media (max-width: 480px)': {
      display: 'flex',
      width: '90%',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
  }
}));

const DashboardsList = ({ items, linkUrlPrefix }) => {
  const classes = useStyles();
  const tempVariableCheckBuild = '';

  return (
    <Grid container direction="row" justify="flex-start" alignItems="stretch">
      {items &&
        items.map(item => (
          <Grid item xs={12} md={4} key={item.id}>
            <Link to={`/${linkUrlPrefix}/${item.id}`} className={classes.link}>
              <Box
                width="100%"
                p={2}
                boxShadow={2}
                borderTop={3}
                borderColor="#346C9F"
                className={classes.container}
              >
                <TypographyWithTooltip
                  tooltipProps={{ placement: 'top', TransitionComponent: Zoom, arrow: true }}
                  variant="h5"
                  gutterBottom
                  className={classes.title}
                >
                  {item.name}
                </TypographyWithTooltip>
                <Divider style={{ width: '100%' }} />
                {item.masterObjectType && (
                  <Typography
                    className={classes.description}
                  >{`Master Object Type: ${item.masterObjectType}`}</Typography>
                )}
                {item.masterObjectName && (
                  <Typography
                    className={classes.description}
                  >{`Master Object Name: ${item.masterObjectName}`}</Typography>
                )}

                {item.description && !item.tableData && (
                  <Typography
                    variant="subtitle1"
                    noWrap={item.description.length > 150}
                    gutterBottom
                    className={classes.description}
                  >
                    {item.description.replace(/<[^>]*>?/gm, '')}
                  </Typography>
                )}

                {item.tableData && (
                  <div className={classes.tableContainer}>
                    {item.tableData.map((item, index) => {
                      return (
                        <div className={classes.tableRow}
                         key={index}
                         >
                          <Typography  
                            variant="subtitle1"
                            gutterBottom
                            className={classes.tableTitle}>{item.Key}
                          </Typography>
                          <Typography  
                            variant="subtitle1"
                            gutterBottom
                            className={classes.description}>
                              {item.Value}
                          </Typography>
                        </div>
                      )
                    })}
                  </div>
                  )}
              </Box>
            </Link>
          </Grid>
        ))}
    </Grid>
  );
};

DashboardsList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string
    })
  ).isRequired,
  linkUrlPrefix: PropTypes.string.isRequired
};

export default DashboardsList;
